import type { PropsWithChildren } from 'react';
import type React from 'react';

import type { EmptyProps } from '@change-corgi/core/types';
import { TrackingContext } from '@change-corgi/core-react/tracking';

import { convertToUsdNumber } from '#src/app/shared/utils/currency';

import { useContributionsPageData } from './pageData';
import { useContributionsPageState } from './pageState';

export const ContributionsPageTrackingContextProvider: React.FC<PropsWithChildren<EmptyProps>> = ({ children }) => {
	const { data } = useContributionsPageData();
	const [
		{
			subscription: { id, amount, createdAt, currencyCode: subsCurrencyCode },
		},
	] = useContributionsPageState();

	const exchangeRate = data.currencyExchangeRate ?? 1;

	return (
		<TrackingContext
			properties={{
				context: 'account_settings',
				emitter: 'front_end',
				local_amount: amount,
				amount: convertToUsdNumber(amount, exchangeRate, subsCurrencyCode),
				subscription_created_at: createdAt,
				currency: subsCurrencyCode,
				subscription_id: id,
			}}
		>
			{children}
		</TrackingContext>
	);
};
